// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aVNuMks0AHi7FOwBO8Ob,.CeilhNypxrUyy1m9XfNa{display:flex;padding-block:8px}.CeilhNypxrUyy1m9XfNa{width:100%}`, "",{"version":3,"sources":["webpack://./src/widgets/MessageFormFields/RinglessMessageField/ui/RinglessMessageFieldActions/styles.module.scss"],"names":[],"mappings":"AAAA,4CAEE,YAAA,CACA,iBAAA,CAEF,sBACE,UAAA","sourcesContent":[".wrap,\n.recordAudio {\n  display: flex;\n  padding-block: 8px;\n}\n.recordAudio {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `aVNuMks0AHi7FOwBO8Ob`,
	"recordAudio": `CeilhNypxrUyy1m9XfNa`
};
export default ___CSS_LOADER_EXPORT___;
